import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { TranslateService } from '../../shared/services/translate.service';

type LoginForm = FormGroup<{
  email: FormControl<NonNullable<string>>;
  password: FormControl<NonNullable<string>>;
}>;

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent {
  form: LoginForm = new FormGroup({
    email: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required, Validators.email],
    }),
    password: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
  });

  isSubmitting = false;
  errorMessage = '';

  constructor(
    private auth: AuthService,
    private router: Router,
    private tSvc: TranslateService,
  ) {}

  t(key: string) {
    return this.tSvc.translate(key);
  }

  get email() {
    return this.form.controls.email;
  }

  get password() {
    return this.form.controls.password;
  }

  onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;
    this.errorMessage = '';

    this.auth.login(this.email.value, this.password.value).subscribe({
      next: () => {
        this.isSubmitting = false;
        this.router.navigate(['/app']);
      },
      error: (error) => {
        console.log('Login error:', error);
        this.errorMessage =
          error?.error?.message ??
          error?.message ??
          'Login failed. Please check your credentials and try again.';
        this.isSubmitting = false;
      },
    });
  }
}
